export const UPDATE_SUMMARY_FILTERS = 'UPDATE_SUMMARY_FILTERS';

const updateSummaryFilters = (filters) => ({ filters, type: UPDATE_SUMMARY_FILTERS });

export {
  updateSummaryFilters,
};
